import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import {
  ACTION_CREATE,
  ACTION_DETAILS,
  ACTION_LIST,
  ACTION_UPDATE,
} from "models/role/action";
import {
  SUBJECT_ADMIN,
  SUBJECT_OWNER_USER,
  SUBJECT_USER,
} from "models/role/subject";
import { lazyRetry } from "utils/lazyRetry";

import type { Route } from "routes/RouteModel";

const UserList = lazyRetry(() => import("../pages/List"), "UserManagementView");
const UserDetails = lazyRetry(
  () => import("../pages/Details"),
  "UserManagementView"
);
const UserEdit = lazyRetry(
  () => import("../pages/Edit"),
  "UserManagementManage"
);
const UserCreate = lazyRetry(
  () => import("../pages/Create"),
  "UserManagementManage"
);

export const userManagementRoutes: Route = {
  title: [COMMON_TRANSLATION_KEYS.users, COMMON_TRANSLATION_KEYS.list],
  path: "/configuration/users",
  component: UserList,
  showChildrenInSidebar: false,
  can: {
    do: ACTION_LIST,
    on: SUBJECT_USER,
  },
  children: [
    {
      path: "/configuration/users/create",
      title: [COMMON_TRANSLATION_KEYS.users, COMMON_TRANSLATION_KEYS.new],
      component: UserCreate,
      can: {
        or: [
          {
            do: ACTION_CREATE,
            on: SUBJECT_USER,
          },
          {
            do: ACTION_CREATE,
            on: SUBJECT_OWNER_USER,
          },
          {
            do: ACTION_CREATE,
            on: SUBJECT_ADMIN,
          },
        ],
      },
    },
    {
      path: "/configuration/users/:id/edit",
      title: [COMMON_TRANSLATION_KEYS.users, COMMON_TRANSLATION_KEYS.edit],
      component: UserEdit,
      can: {
        or: [
          {
            do: ACTION_UPDATE,
            on: SUBJECT_USER,
          },
          {
            do: ACTION_UPDATE,
            on: SUBJECT_OWNER_USER,
          },
          {
            do: ACTION_UPDATE,
            on: SUBJECT_ADMIN,
          },
        ],
      },
    },
    {
      path: "/configuration/users/:id",
      title: [COMMON_TRANSLATION_KEYS.users, COMMON_TRANSLATION_KEYS.details],
      component: UserDetails,
      can: {
        do: ACTION_DETAILS,
        on: SUBJECT_USER,
      },
    },
  ],
};
